module.exports = __webpack_public_path__ + "img/chou.136580e1.png";